export const parseMediaQuery = (row: string) => row.replace(/@media /, '')
